import type { TowerDesign } from "@/game/towerSpec";
import type { Material } from "@/physics/model";
import { CATALOG } from "@/game/appurtenances";

/**
 * Nags Head 175 ft monopole — real F.C.I. Towers pole at 5401 S. Croatan Hwy,
 * Nags Head NC (Verizon NF126), from reference_towers/02_engineering_drawings/
 * NC_NagsHead_monopole_175ft_structural.pdf (tnxTower SA).
 *   - 18-sided slip-joined tapered tube, 175 ft (53.34 m). Grade 65 ksi (A572-65).
 *   - TIA/EIA-222-G, Structure Class II, 130 mph, Exp C. Governing moment 6633
 *     kip-ft (8994 kN·m), axial 50 kip (222 kN), shear 58 kip (258 kN).
 *   - Verizon panels at 161 ft; AT&T 171, nTelos 151, whip 110 ft.
 * Per-section pole diameters not tabulated in the report → base/tip OD ESTIMATED
 * for a 175 ft 18-sided pole (~62"→20"). Foundation not read → competent pier.
 */
const A572_65: Material = { name: "A572 Gr65", E: 200e9, Fy: 448e6, rho: 7850 };
const AZ = [0, (2 * Math.PI) / 3, (4 * Math.PI) / 3];

export const design: TowerDesign = {
  id: "monopole-nagshead-175ft",
  name: "Monopole (Nags Head 175 ft)",
  description: "Real 175 ft coastal monopole, Nags Head NC (Verizon NF126, 130 mph).",
  author: "reference: NC Nags Head 175 ft tnxTower SA (dims partly estimated)",
  spec: {
    type: "monopole",
    height: 53.34,
    stack: {
      faces: 12, panels: 16,
      baseRadius: 0.78, topRadius: 0.26,
      legSection: "legXXL", braceSection: "braceHeavy",
      legMaterial: A572_65, braceMaterial: A572_65, bracing: "X",
    },
    shell: { baseDiameter: 1.57, topDiameter: 0.51 }, // estimated 62"→20"
    foundation: {
      soil: "loose-sand", // Outer Banks coastal sand
      base: { type: "pier", width: 3.0, diameter: 3.0, depth: 9.0, concrete: "c30" },
      connection: {
        kind: "anchorBolts", nBolts: 16, bolt: "b2_0", grade: "f1554_105",
        boltCircleDia: 1.6, embedment: 0.5, edgeDistance: 0.32,
        platePlanArea: 2.4, plateThickness: 0.06, plateGrade: "a36rod", fc: 30e6,
      },
    },
    loads: [
      ...AZ.flatMap((azimuth) => [
        { appurtenance: CATALOG.panelSector, height: 49.1, azimuth }, // Verizon 161 ft
        { appurtenance: CATALOG.panelSector, height: 52.1, azimuth }, // AT&T 171 ft
        { appurtenance: CATALOG.rru, height: 49.1, azimuth },
      ]),
      { appurtenance: CATALOG.omni, height: 33.5, azimuth: 0 }, // whip 110 ft
      { appurtenance: CATALOG.coaxBundle, height: 52.1, runLength: 52.1 },
    ],
  },
};
